type TaskGenerator<T> = () => Promise<T>;

type QueueItem<T> = {
  generator: TaskGenerator<T>;
  resolve: (value: T) => void;
  reject: (reason?: any) => void;
};

export default class TaskQueue<T = void> {
  private tasks: QueueItem<T>[] = [];
  private concurrency = 0;

  constructor(private readonly concurrencyLimit: number = 1) {}

  async enqueue(generator: TaskGenerator<T>): Promise<T> {
    return new Promise((resolve, reject) => {
      this.tasks.push({
        generator,
        resolve,
        reject,
      });

      void this.process();
    });
  }

  private process() {
    if (!(this.tasks.length > 0 && this.concurrency < this.concurrencyLimit)) {
      return;
    }

    ++this.concurrency;
    const queueItem = this.tasks.shift();

    if (queueItem) {
      queueItem
        .generator()
        .then((value) => {
          queueItem.resolve(value);
        })
        .catch((error) => {
          queueItem.reject(error);
        })
        .finally(() => {
          --this.concurrency;
          void this.process();
        });
    }
  }
}
